import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraButton, SpecraInput, SpecraSelect, SpecraText } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
import { useUploadArtifacts } from '../../hooks/useDeliveryDocuments';
import { useEntityArtifacts } from './documentHooks';
/** A source is uploaded or selected explicitly; evidence stance is chosen by the parent. */ export function ThemeDocumentInput({ captureProjectId, value, onChange }) {
    const sources = useEntityArtifacts('capture_project', captureProjectId);
    const upload = useUploadArtifacts();
    const [file, setFile] = useState();
    const [error, setError] = useState('');
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-2",
        children: [
            /*#__PURE__*/ _jsx(SpecraText, {
                size: "meta",
                children: "Select a permitted Pursuit document or upload a new source."
            }),
            sources.isLoading && /*#__PURE__*/ _jsx(SpecraText, {
                size: "meta",
                children: "Loading documents…"
            }),
            sources.isError && /*#__PURE__*/ _jsx(SpecraText, {
                size: "meta",
                children: "Unable to load documents. You can still upload a source."
            }),
            /*#__PURE__*/ _jsxs(SpecraSelect, {
                "aria-label": "Supporting document",
                "data-testid": Testids.capture.themeDocumentSelect,
                value: value,
                onChange: (event)=>onChange(event.target.value),
                children: [
                    /*#__PURE__*/ _jsx("option", {
                        value: "",
                        children: "Choose a Pursuit document"
                    }),
                    value && !(sources.data ?? []).some((a)=>a.artifactId === value) && /*#__PURE__*/ _jsx("option", {
                        value: value,
                        children: "Uploaded document"
                    }),
                    (sources.data ?? []).map((a)=>/*#__PURE__*/ _jsx("option", {
                            value: a.artifactId,
                            children: a.filename
                        }, a.artifactId))
                ]
            }),
            /*#__PURE__*/ _jsx(SpecraInput, {
                type: "file",
                "aria-label": "Upload evidence document",
                "data-testid": Testids.capture.themeDocumentUpload,
                disabled: upload.isPending,
                onChange: (e)=>{
                    setFile(e.target.files?.[0]);
                    setError('');
                }
            }),
            /*#__PURE__*/ _jsx(SpecraButton, {
                size: "sm",
                "data-testid": Testids.capture.themeDocumentUploadButton,
                disabled: !file || upload.isPending,
                onClick: async ()=>{
                    if (!file || upload.isPending) return;
                    setError('');
                    try {
                        const result = await upload.mutateAsync({
                            files: [
                                file
                            ]
                        });
                        if (result.files[0]) {
                            onChange(result.files[0].artifactId);
                            setFile(undefined);
                        } else setError(result.failed[0]?.error || 'Upload failed');
                    } catch (err) {
                        setError(err instanceof Error ? err.message : 'Upload failed');
                    }
                },
                children: upload.isPending ? 'Uploading source…' : 'Upload source'
            }),
            error && /*#__PURE__*/ _jsx(SpecraText, {
                size: "meta",
                role: "alert",
                children: error
            }),
            value && /*#__PURE__*/ _jsx(SpecraText, {
                size: "meta",
                children: "Document selected. Save the evidence below to attach it to this theme."
            })
        ]
    });
}
